import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
export var convertValuesToResponse = function convertValuesToResponse(value) {
  return Object.entries(value).map(function (entry) {
    return {
      id: entry[0],
      checked: entry[1]
    };
  });
};
export var checkedValue = function checkedValue(value) {
  var values = convertValuesToResponse(value).filter(function (item) {
    return item.checked;
  });
  var newValue = {};
  for (var i = 0; i < values.length; i++) {
    newValue[values[i].id] = values[i].checked;
  }
  return newValue;
};
export var getInitialValue = function getInitialValue(initial) {
  var newValue = {};
  for (var i = 0; i < initial.length; i++) {
    newValue[initial[i].id] = true;
  }
  return newValue;
};
export var isOptionChecked = function isOptionChecked(option, value) {
  return typeof value[option.id] !== 'undefined';
};